import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  Divider,
  Avatar,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { decryptData } from "../../../../crypto";
import { useLanguages } from "../../../../context/LanguagesContext";
import { toast } from "react-toastify";
import socket from "../../../../socket/socket";
import ROUTES_NAME from "../../../../constants/RoutesName";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../../context/ProfileContext";
import userAvatar from "../../../../images/userAvatar.png";
import SubmissionPopupReLogin from "../../../../components/popups/SubmissionPopupReLogin";
import { useQuestionSection } from "../../../../hooks/iit/useQuestionSection";

export default function InstructionsPageIpMat() {
  const [step, setStep] = useState(1);
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const { profile } = useProfile();

  const { selectedLanguage } = useLanguages();

  const { showSubmissionPopupReLogin, countdownByHead } = useQuestionSection(
    {}
  );

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .catch((err) => alert("Please use F11 for fullscreen"));
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    setAccepted(false);
  }, [step]);

  const handleStart = () => {
    if (accepted) {
      navigate(ROUTES_NAME.TEST);
      sessionStorage.setItem("loginTime", new Date().getTime());
      sessionStorage.setItem("examStarted", true);
      sessionStorage.removeItem("candidateLoggedinToInstructionsPage");
      const examId = sessionStorage.getItem("examId");
      const userId = sessionStorage.getItem("userId");
      socket.emit("changeStatus", {
        examId,
        userId,
        status: "Giving",
      });
      toggleFullscreen();
    } else {
      toast.warning("Please confirm that you have read the instructions!");
    }
  };

  
  return (
    <Box>
      <div style={{ display: "flex", gap: "10px" }}>
        {/* LEFT CONTENT */}
        <div style={{ width: "80%", height: "100vh" }}>
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              borderRight: "1px solid black",
            }}
          >
            {/* HEADER */}
            <Box sx={{ bgcolor: "#cfeef7", p: 1 }}>
              <Typography variant="h6">
                {step === 1 ? "Instructions" : "Other Important Instructions"}
              </Typography>
            </Box>

            {/* SCROLLABLE CONTENT */}
            <div style={{ padding: 2, overflowY: "auto", flex: 1 }}>
              {step !== 1 ? <GeneralInstructions /> : <OtherInstructions />}
            </div>
            {step === 2 && (
              <div
                style={{
                  float: "end",
                }}
              >
                <Divider sx={{ my: 2 }} />
                <div>
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      checked={accepted}
                      onChange={(e) => setAccepted(e.target.checked)}
                    />
                    <Typography fontWeight="bold">
                      Declaration by the Candidate:
                    </Typography>
                  </Box>

                  <Typography sx={{ ml: 4, pr: 1, pb: 2 }}>
                    {selectedLanguage === "english"
                      ? "I Have Read And Understood The Instructions. All Computer Hardware Allotted To Me Are In Proper Working Condition. I Declare That No Prohibited Gadget Like Mobile Phone, Bluetooth Devices Etc., Or Any Prohibited Material Is With Me In The Examination Hall. I Agree That If Found Guilty Of Any Malpractice, I May Be Debarred From This Test And/Or Subjected To Disciplinary Action, Which May Include A Ban From Future Tests/Examinations."
                      : "मैंने निर्देश पढ़े और समझे हैं। मुझे आवंटित सभी कंप्यूटर हार्डवेयर ठीक काम कर रहे हैं। मैं घोषित करता हूं कि परीक्षा हॉल में मेरे पास कोई प्रतिबंधित गैजेट जैसे मोबाइल फोन, ब्लूटूथ उपकरण आदि या कोई भी प्रतिबंधित सामग्री नहीं है। मैं सहमत हूं कि यदि किसी भी अनुचित प्रक्रिया का दोषी पाया जाता है, तो मुझे इस परीक्षण से वंचित किया जा सकता है और/या अनुशासनात्मक कार्रवाई के अधीन किया जा सकता है, जिसमें भविष्य के परीक्षणों/परीक्षाओं से प्रतिबंध शामिल हो सकता है।"}
                  </Typography>
                </div>
              </div>
            )}
            {/* FOOTER BUTTONS */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: step === 2 ? "space-between" : "end",
                borderTop: "1px solid black",
              }}
            >
              {step === 2 && (
                <Button
                  variant="outlined"
                  onClick={() => setStep(1)}
                  startIcon={<ArrowBackIosIcon />}
                  sx={{
                    borderColor: "black",
                    color: "black",
                    textTransform: "none",
                    fontSize: "16px",
                    "&:hover": {
                      borderColor: "black",
                      backgroundColor: "#104a77",
                      color: "white",
                    },
                  }}
                >
                  Previous
                </Button>
              )}

              {step === 1 && (
                <Button
                  variant="outlined"
                  onClick={() => setStep(2)}
                  endIcon={<ArrowForwardIosIcon />}
                  sx={{
                    borderColor: "black",
                    color: "black",
                    textTransform: "none",
                    fontSize: "16px",
                    "&:hover": {
                      borderColor: "black",
                      backgroundColor: "#104a77",
                      color: "white",
                    },
                  }}
                >
                  Next
                </Button>
              )}

              {step === 2 && (
                <Button
                  variant="contained"
                  disabled={!accepted}
                  onClick={handleStart}
                  sx={{ backgroundColor: "#104a77" }}
                >
                  I am ready to begin
                </Button>
              )}
            </Box>
          </div>
        </div>

        {/* RIGHT PROFILE */}
        <div style={{ width: "20%" }}>
          <div
            style={{
              // height: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              paddingTop: 20,
            }}
          >
            {/* <Avatar sx={{ width: 80, height: 80, mb: 2 }}>
              <PersonIcon fontSize="large" />
            </Avatar> */}
            <div
              style={{
                width: "40%",
                margin: "0 auto",
                display: "flex",
                background: "#E0E0E2",
                borderRadius: "10px",
                paddingTop: "5px",
                paddingBottom: "5px",
                marginBottom: "5px",
              }}
            >
              <img
                src={profile?.image_url || userAvatar}
                alt="Profile IMG"
                style={{
                  maxWidth: "100%",
                  aspectRatio: "1 / 1",
                  borderRadius: "10px",
                  margin: "auto",
                }}
              />{" "}
            </div>
            <Typography variant="h6">{profile?.full_name}</Typography>
          </div>
        </div>
      </div>
      <SubmissionPopupReLogin
        open={showSubmissionPopupReLogin}
        countdown={countdownByHead}
      />
    </Box>
  );
}

/* ================= COMPONENTS ================= */

function GeneralInstructions() {
  const [examInstructions, setExamInstructions] = useState();
  const { selectedLanguage } = useLanguages();

  useEffect(() => {
    if (selectedLanguage === "english") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("genralInstructionEn"))
      );
      // setPopupInstructions(
      // "I Have Read And Understood The Instructions. All Computer Hardware Allotted To Me Are In Proper Working Condition. I Declare That No Prohibited Gadget Like Mobile Phone, Bluetooth Devices Etc., Or Any Prohibited Material Is With Me In The Examination Hall. I Agree That If Found Guilty Of Any Malpractice, I May Be Debarred From This Test And/Or Subjected To Disciplinary Action, Which May Include A Ban From Future Tests/Examinations."
      // );
    }
    if (selectedLanguage === "hindi") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("genralInstructionHi"))
      );
      // setPopupInstructions(
      // "मैंने निर्देश पढ़े और समझे हैं। मुझे आवंटित सभी कंप्यूटर हार्डवेयर ठीक काम कर रहे हैं। मैं घोषित करता हूं कि परीक्षा हॉल में मेरे पास कोई प्रतिबंधित गैजेट जैसे मोबाइल फोन, ब्लूटूथ उपकरण आदि या कोई भी प्रतिबंधित सामग्री नहीं है। मैं सहमत हूं कि यदि किसी भी अनुचित प्रक्रिया का दोषी पाया जाता है, तो मुझे इस परीक्षण से वंचित किया जा सकता है और/या अनुशासनात्मक कार्रवाई के अधीन किया जा सकता है, जिसमें भविष्य के परीक्षणों/परीक्षाओं से प्रतिबंध शामिल हो सकता है।"
      // );
    }
  }, [selectedLanguage]);

  return (
    <>
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          padding: "10px 20px",
          fontSize: "1rem",
          lineHeight: 1.6,

          /* Scrollbar */
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px grey",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#4565B7",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#39476B",
          },

          /* Typography */
          "& h1, & h2, & h3, & h4, & h5, & h6": {
            margin: "16px 0 8px",
            lineHeight: 1.3,
          },
          "& p": {
            margin: "8px 0",
          },
          "& ul, & ol": {
            paddingLeft: "24px",
          },
          "& li": {
            margin: "4px 0",
          },

          /* ✅ Image Fix */
          "& img": {
            display: "block",
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
          },

          /* Media Query */
          "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "0.7rem",

            "& h1, & h2, & h3, & h4, & h5, & h6": {
              margin: "12px 0 6px",
            },
            "& ul, & ol": {
              paddingLeft: "18px",
            },
          },
        }}
        dangerouslySetInnerHTML={{ __html: examInstructions }}
      />
    </>
  );
}

function OtherInstructions() {
  const [examInstructions, setExamInstructions] = useState();
  const { selectedLanguage } = useLanguages();

  useEffect(() => {
    if (selectedLanguage === "english") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("examInstructionEn"))
      );
      // setPopupInstructions(
      //   "I Have Read And Understood The Instructions. All Computer Hardware Allotted To Me Are In Proper Working Condition. I Declare That No Prohibited Gadget Like Mobile Phone, Bluetooth Devices Etc., Or Any Prohibited Material Is With Me In The Examination Hall. I Agree That If Found Guilty Of Any Malpractice, I May Be Debarred From This Test And/Or Subjected To Disciplinary Action, Which May Include A Ban From Future Tests/Examinations."
      // );
    }
    if (selectedLanguage === "hindi") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("examInstructionHi"))
      );
      // setPopupInstructions(
      //   "मैंने निर्देश पढ़े और समझे हैं। मुझे आवंटित सभी कंप्यूटर हार्डवेयर ठीक काम कर रहे हैं। मैं घोषित करता हूं कि परीक्षा हॉल में मेरे पास कोई प्रतिबंधित गैजेट जैसे मोबाइल फोन, ब्लूटूथ उपकरण आदि या कोई भी प्रतिबंधित सामग्री नहीं है। मैं सहमत हूं कि यदि किसी भी अनुचित प्रक्रिया का दोषी पाया जाता है, तो मुझे इस परीक्षण से वंचित किया जा सकता है और/या अनुशासनात्मक कार्रवाई के अधीन किया जा सकता है, जिसमें भविष्य के परीक्षणों/परीक्षाओं से प्रतिबंध शामिल हो सकता है।"
      // );
    }
  }, [selectedLanguage]);

  return (
    <>
      {/* import { Box } from "@mui/material"; */}

      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          padding: "10px 20px",
          fontSize: "1rem",
          lineHeight: 1.6,

          /* Scrollbar */
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px grey",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#4565B7",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#39476B",
          },

          /* Typography */
          "& h1, & h2, & h3, & h4, & h5, & h6": {
            margin: "16px 0 8px",
            lineHeight: 1.3,
          },
          "& p": {
            margin: "8px 0",
          },
          "& ul, & ol": {
            paddingLeft: "24px",
          },
          "& li": {
            margin: "4px 0",
          },

          /* ✅ Image Fix */
          "& img": {
            display: "block",
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
          },

          /* Media Query */
          "@media (min-width: 800px) and (max-width: 898px)": {
            fontSize: "0.7rem",

            "& h1, & h2, & h3, & h4, & h5, & h6": {
              margin: "12px 0 6px",
            },
            "& ul, & ol": {
              paddingLeft: "18px",
            },
          },
        }}
        dangerouslySetInnerHTML={{ __html: examInstructions }}
      />
    </>
  );
}
